'use client';

import { useEffect } from 'react';

// Хелпер резолва и очистки стека (внутри iframe)
const getMappedStack = async (error) => {
if (!error) return null;
try {
const StackTrace = (await import('stacktrace-js')).default;
const frames = await StackTrace.fromError(error);

// Отфильтровываем системные файлы и react-dom, оставляя только ваш код
const cleanFrames = frames.filter((frame) => {
const fileName = frame.fileName || '';
return !fileName.includes('node_modules') && !fileName.includes('react-dom');
});

return (cleanFrames.length ? cleanFrames : frames)
.map((frame) => frame.toString())
.join('\n');
} catch {
return error.stack || null;
}
};

export default function ContextMenuListener() {
useEffect(() => {
// Мост к редактору gefestai.com нужен только внутри iframe
if (window.self === window.top) return;

const PARENT_ORIGIN = 'https://gefestai.com';

// 1. Обработка контекстного меню
const handleContextMenu = (event) => {
event.preventDefault();
const clickedElement = event.target;

if (typeof window !== 'undefined' && window.parent) {
window.parent.postMessage({
type: 'context-menu',
payload: {
html: clickedElement.outerHTML,
x: event.clientX,
y: event.clientY,
url: window.location.pathname,
},
}, PARENT_ORIGIN);
}
};

// 2. Перехват стандартных JS-ошибок
const handleJsError = async (event) => {
if (typeof window !== 'undefined' && window.parent) {
const mappedStack = await getMappedStack(event.error);

window.parent.postMessage({
type: 'js-error',
payload: {
message: event.message,
filename: event.filename,
lineno: event.lineno,
colno: event.colno,
stack: mappedStack || (event.error ? event.error.stack : null),
url: window.location.pathname,
},
}, PARENT_ORIGIN);
}
};

// 3. Перехват необработанных Promise
const handleUnhandledRejection = async (event) => {
if (typeof window !== 'undefined' && window.parent) {
const errorObj = event.reason instanceof Error ? event.reason : null;
const mappedStack = errorObj ? await getMappedStack(errorObj) : null;

window.parent.postMessage({
type: 'promise-error',
payload: {
reason: event.reason?.message || String(event.reason),
stack: mappedStack || event.reason?.stack || null,
url: window.location.pathname,
},
}, PARENT_ORIGIN);
}
};

// 4. Перехват вызовов console.error(...)
const originalConsoleError = console.error;
console.error = (...args) => {
originalConsoleError.apply(console, args);

if (typeof window !== 'undefined' && window.parent) {
window.parent.postMessage({
type: 'console-error',
payload: {
messages: args.map(arg =>
typeof arg === 'object' ? JSON.stringify(arg) : String(arg)
),
url: window.location.pathname,
},
}, PARENT_ORIGIN);
}
};

document.addEventListener('contextmenu', handleContextMenu);
window.addEventListener('error', handleJsError);
window.addEventListener('unhandledrejection', handleUnhandledRejection);

return () => {
document.removeEventListener('contextmenu', handleContextMenu);
window.removeEventListener('error', handleJsError);
window.removeEventListener('unhandledrejection', handleUnhandledRejection);
console.error = originalConsoleError;
};
}, []);

return null;
}
